import { render, staticRenderFns } from "./ModalActionConfirm.vue?vue&type=template&id=046da19d&scoped=true"
import script from "./ModalActionConfirm.vue?vue&type=script&lang=ts"
export * from "./ModalActionConfirm.vue?vue&type=script&lang=ts"
import style0 from "./ModalActionConfirm.vue?vue&type=style&index=0&id=046da19d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046da19d",
  null
  
)

export default component.exports